import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FilterAttributeOptionComponentDef } from '@df/catalog-ui/listing/filter/filter-attribute-option.component.def';
import { Model } from '@df/catalog/model';
import { FacetUrlPipe } from '@df/module-facet-url/util/facet-url.pipe';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'filter-attribute-option',
    templateUrl: './filter-attribute-option.html',
    styleUrl: './filter-attribute-option.scss',
    standalone: true,
    imports: [CommonModule, DfImageDirective, FacetUrlPipe, GridModule, HideUpComponent, HrefComponent, ToggleModule, TranslatePipe]
})
export class FilterAttributeOptionComponent<T extends Model> extends FilterAttributeOptionComponentDef<T> {
    getSelectedOptionsForFilter() {
        if (this.filter) {
            return this.filter.getSelectedOptions().map(i => i.label);
        }
    }
}
